import { Component, ViewChild } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DataGridView, DataGridViewCollumn } from "../../../Componente/DataGridView";
import { LeitsetlleEdit } from "../../Controlls/EditViews/LeitsetlleEdit";
import { PopUpView } from "../../../Componente/PopUpView";
import { Leitstelle } from "../../../Api/DcoApi/Admin/AdminClasses2";


@Component({
  imports: [
    CommonModule,
    FormsModule,
    DataGridView,
    DataGridViewCollumn, LeitsetlleEdit, PopUpView
  ],
  selector: 'Leitstelle',
  templateUrl: './Leitstelle.html',
  standalone: true,
  styleUrl: './Leitstelle.css'
})
export class LeitstelleList {
  @ViewChild('Grid') childComponent!: DataGridView<Leitstelle>;

  triggerReload() {
    // Call the child component's function safely
    this.childComponent.LoadData();
  }
}
